var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//@ts-check

var noop = function noop() {};

export default function (url, options, callback) {

    if (!options) options = {};
    if (!callback) callback = noop;

    var env = _extends({
        url: url,
        data: '',
        method: 'GET',
        headers: {},
        xhr: new XMLHttpRequest()
    }, options);

    env.xhr.open(env.method, env.url, true);

    if (env.method !== 'GET' && !env.headers['Content-type']) {
        env.xhr.setRequestHeader('Content-type', 'application/json');
    }

    for (var header in env.headers) {
        env.xhr.setRequestHeader(header, env.headers[header]);
    }

    env.xhr.onload = function () {
        if (env.xhr.status >= 200 && env.xhr.status < 300) {
            callback(null, env.xhr.responseText);
        } else {
            callback(new Error(env.xhr.status + ' ' + env.xhr.statusText), env.xhr.responseText);
        }
    };

    env.xhr.onerror = function (e) {
        callback(new Error('network error: ' + (e && e.message) + (e && e.code)));
    };

    env.xhr.ontimeout = function () {
        callback(new Error('timeout'));
    };

    env.xhr.send(env.method === 'GET' ? null : env.data);
}